import env from "src/core/env";
import { Repository } from "src/core/Repository";
import { AllParentFieldsResponse } from "src/models/directorys/directory";
import { getAllDeliveryReportRequest } from "src/models/phongs/DeliveryReport";
import {
  ICreateHistory,
  IUpdateHistory,
} from "src/models/phongs/historyReport";
import { DeleteRequest } from "src/models/Request";

class ClassifyReportRepository extends Repository {
  protected basePath = "/api/cms-service/classify-report";

  constructor() {
    super(env.API_CMS_URL);
  }

  getAll(params: getAllDeliveryReportRequest) {
    return this.request<AllParentFieldsResponse>({
      method: "GET",
      url: "/all",
      params,
    });
  }

  createClassify(params: ICreateHistory) {
    return this.request({
      method: "POST",
      url: "",
      data: params,
    });
  }

  exportClassify(id: string) {
    return this.request({
      method: "POST",
      url: `/${id}/export`,
    });
  }

  deleteClassify(param: DeleteRequest) {
    return this.request({
      method: "DELETE",
      url: `/${param.id}`,
    });
  }

  updateClassify(params: IUpdateHistory) {
    return this.request({
      method: "PUT",
      url: "",
      data: params,
    });
  }
}
export const classifyReportRepository = new ClassifyReportRepository();
